import createIcon from '../../createIcon';

/**
 * @component @name Approval
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxNlYyMkgyMFYxNkMyMCAxNC45IDE5LjEgMTQgMTggMTRINkM0LjkgMTQgNCAxNC45IDQgMTZaTTE4IDE4SDZWMTZIMThWMThaTTEyIDJDOS4yNCAyIDcgNC4yNCA3IDdMMTIgMTRMMTcgN0MxNyA0LjI0IDE0Ljc2IDIgMTIgMlpNMTIgMTFMOSA3QzkgNS4zNCAxMC4zNCA0IDEyIDRDMTMuNjYgNCAxNSA1LjM0IDE1IDdMMTIgMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Approval = createIcon('Approval', [
  [
    'path',
    {
      d: 'M4 16V22H20V16C20 14.9 19.1 14 18 14H6C4.9 14 4 14.9 4 16ZM18 18H6V16H18V18ZM12 2C9.24 2 7 4.24 7 7L12 14L17 7C17 4.24 14.76 2 12 2ZM12 11L9 7C9 5.34 10.34 4 12 4C13.66 4 15 5.34 15 7L12 11Z',
      key: '1gvl6p',
    },
  ],
]);

export default Approval;
